"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByCreationDate = void 0;
const sortByCreationDate = (arr, key, isAsc = false) => {
    let ret = arr.sort((a, b) => new Date(b[key]).getTime() - new Date(a[key]).getTime());
    return isAsc ? ret.reverse() : ret;
};
exports.sortByCreationDate = sortByCreationDate;
